import './helpers/otelHelper.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import { Provider } from "react-redux";
import store from "./redux/store";
import { BrowserRouter as Router } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary'
import FallbackComponent from './CommonComponents/FallbackComponent/FallbackComponent';
import RedirectGuard from './guards/RedirectGuard.jsx';
import { browserLogger } from './helpers/browserLogger';

// ─── Global error handlers (catches errors outside React tree) ───
window.onerror = (message, source, lineno, colno, error) => {
  browserLogger.error('Uncaught global error', error, {
    'error.source': source,
    'code.lineno': lineno,
    'code.colno': colno,
    'error.type': 'window.onerror',
  });
};

window.onunhandledrejection = (event) => {
  const error = event.reason instanceof Error ? event.reason : new Error(String(event.reason));
  browserLogger.error('Unhandled Promise rejection', error, {
    'error.type': 'unhandledrejection',
  });
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Router>
    <Provider store={store}>
      <ErrorBoundary
        FallbackComponent={FallbackComponent}
        onError={(error, info) => {
          browserLogger.error('React ErrorBoundary triggered', error, {
            'error.type': 'react.error_boundary',
            'react.componentStack': info?.componentStack || '',
          });
        }}
      >
        <RedirectGuard />
        <App />
      </ErrorBoundary>
    </Provider>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
